import RowLabel from './RowLabel';
import { RowLabelProps, RowLabelValueProps, RowLabelCombinedProps } from './types'; // MANUAL OVERRIDE

export type { RowLabelProps, RowLabelValueProps, RowLabelCombinedProps };
export default RowLabel;
